import type { Template } from "@/types";

export const PO_01_H1_V0: Template[] = [
{
    id: "po-01-h1v0-01",
    name: "PO 01 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 158, y: 146, width: 899, height: 559, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-02",
    name: "PO 02 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 69, y: 90, width: 1080, height: 671, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-03",
    name: "PO 03 - H1V0",
    albumType: "Hr",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 90, width: 1217, height: 671, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-04",
    name: "PO 04 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 156, y: 0, width: 904, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-05",
    name: "PO 05 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 59, y: 60, width: 1097, height: 730, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-06",
    name: "PO 06 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 1217, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-07",
    name: "PO 07 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 609, y: 213, width: 609, height: 424, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-08",
    name: "PO 08 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 660, y: 250, width: 504, height: 351, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-09",
    name: "PO 09 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 213, width: 609, height: 424, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-01-h1v0-10",
    name: "PO 10 - H1V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v0_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 52, y: 250, width: 504, height: 351, rotation: 0, imageRotation: 0 }
    ],
}
];